import React, {lazy, Suspense} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {I18nextProvider} from 'react-i18next';
import i18n from 'src/i18n/i18n';

import {Provider} from 'react-redux';
import {store} from 'src/redux/store';


const Main = lazy(() => import('./pages/Main'));

function App() {
  return (
    <div
      className='App'
      // onContextMenu={(e) => {
      //   e.preventDefault();
      // }} // 우클릭 방지
    >
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <Suspense fallback={<div></div>}>
              <Switch>
                <Route path='/' component={Main} />
              </Switch>
            </Suspense>
          </BrowserRouter>
        </I18nextProvider>
      </Provider>
    </div>
  );
}

export default App;